<div class="customer-info-container">
    <form [formGroup]="form">
        <div *ngIf="!isNoUserIgnore" class="wrapped-label-checkbox">
            <mat-checkbox formControlName="noCustomer"></mat-checkbox>
            <label for="noCustomer">Customer information not available. This information will be entered at a later date.</label>
        </div>

        <ng-container *ngIf="isUserListLoaded$ | async; else loading">
            <ng-container *ngIf="!fields.noCustomer.value || isNoUserIgnore">
                <div class="form-container">
                    <div class="email-container">
                        <mat-form-field appearance="outline">
                            <mat-label>Email</mat-label>
                            <input
                                matInput
                                id="userObj"
                                lowercase-inp
                                type="email"
                                placeholder="Email"
                                formControlName="userObj"
                                [matAutocomplete]="auto"
                                required
                                (focusout)="checkEmailInOtherEntities()"
                            />
                        </mat-form-field>
                        <mat-error>
                            <span class="email-error" *ngIf="fields.userObj.touched && fields.email.errors">
                                {{ fields.email.errors.EmailInvalid || fields.email.errors.emailExists }}
                            </span>
                        </mat-error>
                        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                            <mat-option *ngFor="let customer of customers$ | async" [value]="customer">{{ customer.email }} </mat-option>
                        </mat-autocomplete>
                    </div>

                    <mat-form-field appearance="outline" *letVar="fields.firstName as field">
                        <mat-label>First Name</mat-label>
                        <input matInput id="firstName" type="text" placeholder="First Name" formControlName="firstName" required />
                        <mat-error>
                            <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" *letVar="fields.lastName as field">
                        <mat-label>Last Name</mat-label>
                        <input matInput id="lastName" type="text" placeholder="Last Name" formControlName="lastName" required />
                        <mat-error>
                            <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                        </mat-error>
                    </mat-form-field>

                    <phone-input label="Phone Number" [theForm]="form" field="phone" [notRequired]="'false'"></phone-input>
                    <mat-form-field appearance="outline">
                        <mat-label>Phone Number Type</mat-label>
                        <select
                            matNativeControl
                            id="phoneType"
                            formControlName="phoneType"
                            placeholder="-- Select phone type --"
                            [errorStateMatcher]="errorMatcher"
                        >
                            <option *ngFor="let type of phoneTypeList" [value]="type">
                                {{ type }}
                            </option>
                        </select>
                    </mat-form-field>

                    <ng-container *ngFor="let phoneGroup of additionalPhoneNumbers.controls; let i = index">
                        <div class="phone-input-container container-flex">
                            <div class="show-remove-icon">
                                <phone-input
                                    id="phone-{{ i }}"
                                    label="Phone Number"
                                    [theForm]="phoneGroup"
                                    field="phone"
                                    [notRequired]="'true'"
                                ></phone-input>
                            </div>
                            <button
                                (click)="removePhoneNumber(i)"
                                class="mat-button remove-phone-btn"
                                [attr.aria-label]="'remove phone number ' + (i + 2)"
                            >
                                <mat-icon class="close-icon">close</mat-icon>
                            </button>
                        </div>
                        <div class="show-remove-icon">
                            <mat-form-field appearance="outline">
                                <mat-label>Phone Number Type</mat-label>
                                <select
                                    matNativeControl
                                    id="phoneType-{{ i }}"
                                    [formControl]="phoneGroup.get('phoneType')"
                                    placeholder="-- Select phone type --"
                                    [errorStateMatcher]="errorMatcher"
                                >
                                    <option *ngFor="let type of phoneTypeList" [value]="type">
                                        {{ type }}
                                    </option>
                                </select>
                            </mat-form-field>
                        </div>
                    </ng-container>
                    <button
                        type="button"
                        (click)="addPhoneNumber()"
                        [disabled]="additionalPhoneNumbers.controls.length > 1"
                        class="add-phone-number-btn"
                        mat-stroked-button
                    >
                        <span aria-hidden="true">+ </span>Add Phone Number
                    </button>

                    <mat-form-field appearance="outline" class="account-number-field">
                        <mat-label>Account Number</mat-label>
                        <input matInput id="accountNumber" type="text" placeholder="Account Number" formControlName="accountNumber" />
                    </mat-form-field>
                </div>
            </ng-container>
        </ng-container>
    </form>
</div>

<ng-template #loading>
    <clare-spinner text="Loading users..."></clare-spinner>
</ng-template>
